<template>
<div class='simple-stat-widget'>
  <div class='simple-stat-widget__title-label'>
    {{$t('report.widget.title')}}
  </div>
  <div class='simple-stat-widget__content'>
    <div class='donut-chart'>
      <donut-chart
        :series='valuesForChart'
        :colors='colorsFormatted'
        :height='170'
        :width='170'
        :radius='55'
      />
    </div>
    <div class="widget-values">
      <inline-legend-widget-cell
        v-for='(label, index) in labels' :key='index'
        :value='values[index]'
        :color='colorsFormatted[index]'
        :label='label'
      />
    </div>
  </div>
</div>
</template>

<script>
import DonutChart from '@/components/common/DonutChart.vue';
import InlineLegendWidgetCell from '@/components/reports/InlineLegendWidgetCell.vue';

export default {
  name: 'SimpleStatsWidget',
  props: {
    values: {
      required: true,
      type: Array,
    },
    labels: {
      required: true,
      type: Array,
    },
    colors: {
      type: Array,
      default: () => ['#DF399F', '#682FD2', '#FF952C', '#00D0C4'],
    },
  },
  components: {
    InlineLegendWidgetCell,
    DonutChart,
  },
  computed: {
    valuesForChart() {
      return this.values.map(item => (item > 0 ? item : 1));
    },
    colorsFormatted() {
      const currentColors = this.colors;
      const diff = this.values.length - this.colors.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i += 1) {
          let randomColor = Math.floor(Math.random() * 16777215).toString(16);
          while (currentColors.includes(randomColor)) {
            randomColor = Math.floor(Math.random() * 16777215).toString(16);
          }
          currentColors.push(`#${randomColor}`);
        }
      } else if (diff < 0) {
        currentColors.slice(diff * -1);
      }
      return currentColors;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.simple-stat-widget {
  display: flex;
  flex-direction: column;
  &__title-label {
    color: var(--text-primary);
    font-family: $font-family-bold;
    font-size: $font-size-md;
    font-weight: bold;
    line-height: $space-5;
    letter-spacing: 0;
    margin-bottom: $space-2;
  }
  &__content {
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: var(--bg-secondary);
    border-radius: $widget-border-radius;

    .donut-chart {
    }

    .widget-values {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      max-height: rem(208);
    }
  }
}
</style>
<style lang="scss">
.donut-widget {
  .v-divider {
    margin: rem(26) rem(25);
  }
}
</style>
